<p style="text-align: right;cursor: pointer;margin-top: 10px;"><a (click)="goToTenderDetail()"
        target="_self"><strong>&lt; Torna al dettaglio
        </strong></a></p>
<h2 style="font-size: 25px;margin-bottom: 3vh;">{{tenderTitle}}</h2>
<p
    style="font-size: 21px; margin-bottom: 3vh; margin-top: 4vh; font-weight: 400;font-family: Montserrat, Arial, Helvetica, sans-serif !important;">
    DOMANDE E RISPOSTE
</p>
<form [formGroup]="searchForm" id="search-appform">
    <style type="text/css">
        input::-webkit-input-placeholder {
            color: #333333;
            text-align: left;
            font-weight: 300;
            font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover::-webkit-input-placeholder {
            color: #ffffff;
            transition: none;
        }

        /* Firefox < 19 */
        input:-moz-placeholder {
            color: #333333;
            text-align: left;
            font-weight: 300;
            font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover:-moz-placeholder {
            color: #ffffff;
            transition: none;
        }

        /* Firefox > 19 */
        input::-moz-placeholder {
            color: #333333;
            text-align: left;
            font-weight: 300;
            font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover::-moz-placeholder {
            color: #ffffff;
            transition: none;
        }

        /* Internet Explorer 10 */
        input:-ms-input-placeholder {
            color: #333333;
            text-align: left;
            font-weight: 300;
            font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover:-ms-input-placeholder {
            color: #ffffff;
            transition: none;
        }
    </style>

    <div class="fusion-layout-column fusion_builder_column fusion_builder_column_4_5 fusion-builder-column-1 fusion-four-fifth fusion-column-first 4_5"
        style='margin-top:0px;margin-bottom:0px;width:80%;width:calc(80% - ( ( 4% + 4% ) * 0.4 ) );margin-right: 4%;'>
        <div class="fusion-builder-row fusion-row">
            <div class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-11 fusion-one-half fusion-column-first 1_2"
                style='margin-top: 0px;margin-bottom: 0px;width:50%;width:calc(50% - ( ( 4% ) * 0.5 ) );margin-right:4%;'>
                <div class="fusion-column-wrapper"
                    style="background-color:#ffffff;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                    data-bg-url="">
                    <ul class="fusion-checklist fusion-checklist-1" style="font-size:16px;line-height:27.2px;">
                        <li class="fusion-li-item" style="background-color: #fafafa"><span
                                style="height:27.2px;width:27.2px;margin-right:11.2px; margin-right: 10px;padding-top: 5px;padding-right: 0;padding-left: 10px;"
                                class="icon-wrapper circle-no"><i class="fusion-li-icon fas fa-clipboard-list"
                                    style="color:#333333;padding-top: 15px;padding-left: 8px;"></i></span>
                            <div class="fusion-li-item-content" style="margin-left:45px;">
                                <select formControlName="topic"
                                    style="-webkit-appearance: none; -moz-appearance: none;font-size: 16px !important;font-weight: 300;letter-spacing: 1px !important;padding-bottom: 0 !important;padding-left: 5px !important;">
                                    <option [ngValue]="null">Argomento</option>
                                    <option [ngValue]="questionTopic.code" *ngFor="let questionTopic of topics">
                                        {{questionTopic.description}}</option>
                                </select>
                            </div>
                        </li>
                    </ul>
                    <div class="fusion-clearfix"></div>
                </div>
            </div>
            <div class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-12 fusion-one-half fusion-column-last 1_2"
                style='margin-top: 0px;margin-bottom: 0px;width:50%;width:calc(50% - ( ( 4% ) * 0.5 ) );'>
                <div class="fusion-column-wrapper"
                    style="background-color:#ffffff;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                    data-bg-url="">
                    <ul class="fusion-checklist fusion-checklist-2" style="font-size:16px;line-height:27.2px;">
                        <li class="fusion-li-item" style="background-color: #fafafa"><span
                                style="height:27.2px;width:27.2px;margin-right:11.2px; margin-right: 10px;padding-top: 5px;padding-right: 0;padding-left: 10px;"
                                class="icon-wrapper circle-no"><i class="fusion-li-icon fas fa-pen-square"
                                    style="color:#333333;padding-top: 15px;padding-left: 8px;"></i></span>
                            <div class="fusion-li-item-content" style="margin-left:45px;">
                                <input
                                    style="font-size: 16px !important;font-weight: 300;letter-spacing: 1px !important;padding-bottom: 0 !important;padding-left: 5px !important;"
                                    class="ng-app-input" type="text" formControlName="freeText"
                                    placeholder="Testo libero">
                            </div>
                        </li>
                    </ul>
                    <div class="fusion-clearfix"></div>
                </div>
            </div>
        </div>
        <div class="fusion-sep-clear"></div>
        <div class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto;margin-right: auto;margin-top:20px;"></div>
        <div *ngIf="openedFrom === 'participation'" class="fusion-builder-row fusion-row">
            <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                    .fusion-button.button-6 .fusion-button-text,
                    .fusion-button.button-6 i {
                        color: #a5a5a5;
                    }

                    .fusion-button.button-6 .fusion-button-icon-divider {
                        border-color: #a5a5a5;
                    }

                    .fusion-button.button-6:hover .fusion-button-text,
                    .fusion-button.button-6:hover i,
                    .fusion-button.button-6:focus .fusion-button-text,
                    .fusion-button.button-6:focus i,
                    .fusion-button.button-6:active .fusion-button-text,
                    .fusion-button.button-6:active {
                        color: #ffffff;
                    }

                    .fusion-button.button-6:hover .fusion-button-icon-divider,
                    .fusion-button.button-6:hover .fusion-button-icon-divider,
                    .fusion-button.button-6:active .fusion-button-icon-divider {
                        border-color: #ffffff;
                    }

                    .fusion-button.button-6:hover,
                    .fusion-button.button-6:focus,
                    .fusion-button.button-6:active {
                        border-color: #ffffff;
                    }

                    .fusion-button.button-6 {
                        border-color: #333333;
                        border-radius: 0px;
                    }

                    .fusion-button.button-6 {
                        background: #ffffff;
                    }

                    .fusion-button.button-6:hover,
                    .button-6:focus,
                    .fusion-button.button-6:active {
                        background: #ffffff;
                    }
                </style>
                <input type="checkbox" formControlName="myQuestion" id="c1" class="yellowBorderedCheckbox" />
                <label for="c1"><span></span>Cerca solo tra le mie domande.</label>
            </div>
            <div class="fusion-sep-clear"></div>
            <div class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>


        </div>
    </div>

    <div class="fusion-layout-column fusion_builder_column fusion_builder_column_1_5 fusion-builder-column-2 fusion-one-fifth fusion-column-last 1_5"
        style='margin-top:10px;margin-bottom:0px;width:20%;width:calc(20% - ( ( 4% + 4% ) * 0.2 ) );'>
        <div class="fusion-column-wrapper"
            style="padding: 7px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
            data-bg-url="">
            <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                    .fusion-button.button-2 {
                        border-radius: 0px;
                    }
                </style><a (click)="searchQuestions()"
                    class="fusion-button button-flat fusion-button-default-size button-default button-2 fusion-button-span-yes fusion-button-default-type"
                    target="_self"><span class="fusion-button-text">CERCA</span></a>
            </div>
            <div class="fusion-clearfix"></div>
        </div>
    </div>
</form>
<div class="fusion-sep-clear"></div>
<div class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left:auto;margin-right:auto;margin-top:20px;"></div>
<style type="text/css">
    .fusion-accordian #accordion-1383-1 .panel-title a .fa-fusion-box {
        color: #ffffff;
    }

    .fusion-accordian #accordion-1383-1 .panel-title a .fa-fusion-box:before {
        font-size: 16px;
        width: 16px;
    }

    .fusion-accordian #accordion-1383-1 .panel-title a {
        font-size: 18px;
    }

    .fusion-accordian #accordion-1383-1 .fa-fusion-box {
        background-color: #333333;
        border-color: #333333;
    }

    .fusion-accordian #accordion-1383-1 .panel-title a:hover,
    #accordion-1383-1 .fusion-toggle-boxed-mode:hover .panel-title a {
        color: #ffa626;
    }

    .fusion-accordian #accordion-1383-1 .panel-title .active .fa-fusion-box,
    .fusion-accordian #accordion-1383-1 .panel-title a:hover .fa-fusion-box {
        background-color: #ffa626 !important;
        border-color: #ffa626 !important;
    }

    .ng-dark-button {
        background-image: linear-gradient(to top, var(--ng-app-mid-yellow-color), var(--ng-app-dark-yellow-color));
    }

    .ng-dark-button-disabled {
        background-image: linear-gradient(to top, var(--ng-app-dark-grey-color), var(--ng-app-dark-grey-color));
    }

    a.ng-dark-button-disabled span {
        color: #ffffff !important;
        cursor: auto;
    }
</style>
<div class="accordian fusion-accordian"  *ngIf="isEditable()">
    <div class="panel-group" id="accordion-1383-1" role="tablist">
        <div class="fusion-panel panel-default fusion-toggle-no-divider" role="tabpanel">
            <div class="panel-heading">
                <h4 class="panel-title toggle"><a aria-expanded="false" aria-selected="false" id="ngQuestionPanel"
                        aria-controls="questionPanel" role="tab" data-toggle="collapse" data-parent="#accordion-1383-1"
                        data-target="#questionPanel" href="#questionPanel"><span class="fusion-toggle-icon-wrapper"
                            aria-hidden="true"><i class="fa-fusion-box"></i></span><span class="fusion-toggle-heading"
                            style="font-weight: 500;">FAI UNA
                            DOMANDA</span></a>
                </h4>
            </div>
            <div id="questionPanel" class="panel-collapse collapse ">
                <div class="panel-body toggle-content fusion-clearfix">
                    <h5>{{insertQuestionMsg}}</h5>
                </div>
                <div class="fusion-sep-clear"></div>
                <div class="fusion-separator fusion-full-width-sep sep-none"
                    style="margin-left: auto;margin-right: auto;margin-top:10px;"></div>
                <form [formGroup]="questionForm" id="submit-question-appform"
                    style="background-color: var(--ng-app-dark-grey-color); color: #fafafa; padding-right: 3vw; padding-left: 3vw; padding-top: 2vh; font-weight: 500;">
                    <ul class="fusion-checklist fusion-checklist-1" style="font-size:14px;line-height:23.8px;">
                        <li class="fusion-li-item"><span style="height:23.8px;width:23.8px;margin-right:9.8px;"
                                class="icon-wrapper circle-no"><i class="fusion-li-icon fa-clipboard-list fas"
                                    style="color:#fafafa;"></i></span>
                            <div class="fusion-li-item-content" style="margin-left:33.6px;">
                                <p>ARGOMENTO</p>
                            </div>
                        </li>
                    </ul>
                    <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                            .fusion-button.button-1 .fusion-button-text,
                            .fusion-button.button-1 i {
                                color: #a5a5a5;
                            }

                            .fusion-button.button-1 .fusion-button-icon-divider {
                                border-color: #a5a5a5;
                            }

                            .fusion-button.button-1:hover .fusion-button-text,
                            .fusion-button.button-1:hover i,
                            .fusion-button.button-1:focus .fusion-button-text,
                            .fusion-button.button-1:focus i,
                            .fusion-button.button-1:active .fusion-button-text,
                            .fusion-button.button-1:active {
                                color: #ffffff;
                            }

                            .fusion-button.button-1:hover .fusion-button-icon-divider,
                            .fusion-button.button-1:hover .fusion-button-icon-divider,
                            .fusion-button.button-1:active .fusion-button-icon-divider {
                                border-color: #ffffff;
                            }

                            .fusion-button.button-1:hover,
                            .fusion-button.button-1:focus,
                            .fusion-button.button-1:active {
                                border-color: #ffffff;
                            }

                            .fusion-button.button-1 {
                                border-color: #333333;
                                border-radius: 0px;
                            }

                            .fusion-button.button-1 {
                                background: #ffffff;
                            }

                            .fusion-button.button-1:hover,
                            .button-1:focus,
                            .fusion-button.button-1:active {
                                background: #ffffff;
                            }

                            .fusion-button.button-3:hover,
                            .button-3:focus,
                            .fusion-button.button-3:active {
                                background: #333333;
                            }
                        </style>

                        <select formControlName="topic" required (click)="resetError()"
                            style="-webkit-appearance: none; -moz-appearance: none;font-size: 16px !important;font-weight: 300;letter-spacing: 1px !important;padding-bottom: 0 !important;padding-left: 5px !important;">
                            <option [ngValue]="null"></option>
                            <option [ngValue]="questionTopic.code" *ngFor="let questionTopic of topics">
                                {{questionTopic.description}}</option>
                        </select>

                        <div
                            [ngStyle]="{'visibility':questionForm.get('topic').valid || questionForm.get('topic').pristine ? 'hidden':'visible'}">
                            <i class="fas fa-exclamation-triangle" style="color: var(--ng-app-alert-color);"></i>
                            <span style="padding-left: 5px;font-size: 14px;font-weight: 400;">Selezionare un
                                argomento.</span>
                        </div>
                    </div>
                    <div class="fusion-sep-clear"></div>
                    <ul class="fusion-checklist fusion-checklist-1" style="font-size:14px;line-height:23.8px;margin-top: 0px;">
                        <li class="fusion-li-item"><span style="height:23.8px;width:23.8px;margin-right:9.8px;"
                                class="icon-wrapper circle-no"><i class="fusion-li-icon fa-question fas"
                                    style="color:#fafafa;"></i></span>
                            <div class="fusion-li-item-content" style="margin-left:33.6px;">
                                <p>DOMANDA</p>
                            </div>
                        </li>
                    </ul>
                    <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                            .fusion-button.button-1 .fusion-button-text,
                            .fusion-button.button-1 i {
                                color: #a5a5a5;
                            }

                            .fusion-button.button-1 .fusion-button-icon-divider {
                                border-color: #a5a5a5;
                            }

                            .fusion-button.button-1:hover .fusion-button-text,
                            .fusion-button.button-1:hover i,
                            .fusion-button.button-1:focus .fusion-button-text,
                            .fusion-button.button-1:focus i,
                            .fusion-button.button-1:active .fusion-button-text,
                            .fusion-button.button-1:active {
                                color: #ffffff;
                            }

                            .fusion-button.button-1:hover .fusion-button-icon-divider,
                            .fusion-button.button-1:hover .fusion-button-icon-divider,
                            .fusion-button.button-1:active .fusion-button-icon-divider {
                                border-color: #ffffff;
                            }

                            .fusion-button.button-1:hover,
                            .fusion-button.button-1:focus,
                            .fusion-button.button-1:active {
                                border-color: #ffffff;
                            }

                            .fusion-button.button-1 {
                                border-color: #333333;
                                border-radius: 0px;
                            }

                            .fusion-button.button-1 {
                                background: #ffffff;
                            }

                            .fusion-button.button-1:hover,
                            .button-1:focus,
                            .fusion-button.button-1:active {
                                background: #ffffff;
                            }
                        </style>
                        <input class="ng-app-input" type="text" placeholder="Testo della domanda" (click)="resetError()"
                            formControlName="question" required>
                        <div
                            [ngStyle]="{'visibility':questionForm.get('question').valid || questionForm.get('question').pristine ? 'hidden':'visible'}">
                            <i class="fas fa-exclamation-triangle" style="color: var(--ng-app-alert-color);"></i>
                            <span style="padding-left: 5px;font-size: 14px;font-weight: 400;">Inserire la domanda.</span>
                        </div>
                    </div>
                    <div class="ng-spinner">
                        <img *ngIf="loading" src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg" />
                    </div>
                    <div *ngIf="error !== 'no_error'" class="ng-alert">
                        <i class="fas fa-exclamation-triangle" style="color: var(--ng-app-alert-color);"></i>
                        <span style="padding-left: 5px;font-size: 14px;font-weight: 400;">{{error}}</span>
                    </div>
                    <div class="fusion-button-wrapper fusion-aligncenter" style="padding-top: 20px;">
                        <style type="text/css">
                            .fusion-button.button-3 {
                                border-radius: 0px;
                            }
                        </style><a (click)="submitQuestion()"
                            class="fusion-button button-flat fusion-button-default-size button-default button-3 fusion-button-default-span fusion-button-default-type"
                            target="_self"><span class="fusion-button-text">INVIA DOMANDA</span></a>
                    </div>
                    <div class="fusion-sep-clear"></div>
                    <div class="fusion-separator fusion-full-width-sep sep-none"
                        style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
                </form>
            </div>
        </div>
    </div>
</div>
<div class="fusion-sep-clear"></div>
<div *ngIf="!questions || questions.length === 0" style="text-align: center;margin-top: 8vh;margin-bottom: 8vh;">
    <p style="font-size: 1.4rem;"><strong>Non sono ancora state fatte domande per questa gara.</strong></p>
</div>
<div *ngFor="let question of questions" style="margin-top: 3vh;">
    <div [ngStyle]="{'border':question.answer ? '0':'2px solid var(--ng-app-theme-yellow-color)'}">
        <div class="fusion-layout-column fusion_builder_column fusion_builder_column_1_1 fusion-builder-nested-column-5 fusion-one-full fusion-column-first fusion-column-last 1_1"
            style='margin-top: 0px;margin-bottom: 0px;background-color: #fafafa;padding: 3px 6px 3px 10px'>
            <div class="fusion-li-item-content" style="text-align: right;">
                <p style="font-weight: 600; font-size: 15px;margin-bottom: 0;">{{getTopicDescription(question.topic)}}</p>
            </div>
            <ul class="fusion-checklist fusion-checklist-1"
                style="font-size:14px;margin-top: 0;font-weight: 500;">
                <li class="fusion-li-item">
                    <div class="fusion-li-item-content" style="margin-left:5px;font-style: italic;">
                        <p style="font-size: 15px; font-weight: 400;font-style: italic;"> 
                            <span *ngIf="openedFrom === 'tender'">(Autore: {{question.name}} - </span>
                            <span *ngIf="openedFrom !== 'tender'">(</span>
                            <span>Domanda inserita il: {{question.askedOn | date:'d/M/y'}}</span>
                            <span *ngIf="question.answeredOn"> - Risposta data il: {{question.answeredOn | date:'d/M/y'}}</span>
                            <span>)</span>
                        </p>
                    </div>
                </li>
            </ul>
            <ul class="fusion-checklist fusion-checklist-1" style="font-size:19px;line-height:23.8px;font-weight: 500;">
                <li class="fusion-li-item"><span style="height:23.8px;width:23.8px;margin-right:9.8px;"
                        class="icon-wrapper circle-no"><i class="fusion-li-icon fa-question fas"
                            style="color: var(--ng-app-theme-yellow-color)"></i></span>
                    <div class="fusion-li-item-content"
                        style="margin-left:33.6px;color: var(--ng-app-theme-yellow-color);">
                        <p>{{question.question}}</p>
                    </div>
                </li>
            </ul>
            <ul *ngIf="question.answer" class="fusion-checklist fusion-checklist-1"
                style="font-size:14px;line-height:23.8px;font-weight: 500;">
                <li class="fusion-li-item"><span style="height:23.8px;width:23.8px;margin-right:9.8px;"
                        class="icon-wrapper circle-no"><i class="fusion-li-icon fa-file-alt fas"
                            style="color: #333333"></i></span>
                    <div class="fusion-li-item-content" style="margin-left:33.6px;">
                        <p style="font-size: 15px; font-weight: 400;margin-bottom: 2px;">{{question.answer}}</p>
                    </div>
                </li>
            </ul>
            <div class="accordian fusion-accordian" (click)="resetErrorAnswer()"
                *ngIf="(question.answer === null || question.answer === undefined) && openedFrom === 'tender' && isEditable()">
                <div class="panel-group" id="accordion-1383-1" role="tablist">
                    <div class="fusion-panel panel-default fusion-toggle-no-divider" role="tabpanel">
                        <div class="panel-heading">
                            <h4 class="panel-title toggle"><a aria-expanded="false" aria-selected="false"
                                    aria-controls="answerPanel-{{question.id}}" role="tab" data-toggle="collapse"
                                    data-parent="#accordion-1383-1" data-target="#answerPanel-{{question.id}}"
                                    href="#answerPanel-{{question.id}}"><span class="fusion-toggle-icon-wrapper"
                                        aria-hidden="true"><i class="fa-fusion-box"></i></span><span
                                        style="font-size: 16px;" class="fusion-toggle-heading">RISPONDI ALLA
                                        DOMANDA</span></a>
                            </h4>
                        </div>
                        <div id="answerPanel-{{question.id}}" class="panel-collapse collapse"
                            style="margin-bottom: 6px;">
                            <form [formGroup]="answerForm" id="submit-answer-appform"
                                style="background-color: var(--ng-app-dark-grey-color); color: #fafafa; padding-right: 3vw; padding-left: 3vw; padding-top: 2vh; font-weight: 500;">
                                <ul class="fusion-checklist fusion-checklist-1"
                                    style="font-size:14px;line-height:23.8px;">
                                    <li class="fusion-li-item"><span
                                            style="height:23.8px;width:23.8px;margin-right:9.8px;"
                                            class="icon-wrapper circle-no"><i class="fusion-li-icon fa-pen-square fas"
                                                style="color:#fafafa;"></i></span>
                                        <div class="fusion-li-item-content" style="margin-left:33.6px;">
                                            <p>RISPOSTA</p>
                                        </div>
                                    </li>
                                </ul>
                                <div class="fusion-button-wrapper fusion-align-block">
                                    <style type="text/css">
                                        .fusion-button.button-1 .fusion-button-text,
                                        .fusion-button.button-1 i {
                                            color: #a5a5a5;
                                        }

                                        .fusion-button.button-1 .fusion-button-icon-divider {
                                            border-color: #a5a5a5;
                                        }

                                        .fusion-button.button-1:hover .fusion-button-text,
                                        .fusion-button.button-1:hover i,
                                        .fusion-button.button-1:focus .fusion-button-text,
                                        .fusion-button.button-1:focus i,
                                        .fusion-button.button-1:active .fusion-button-text,
                                        .fusion-button.button-1:active {
                                            color: #ffffff;
                                        }

                                        .fusion-button.button-1:hover .fusion-button-icon-divider,
                                        .fusion-button.button-1:hover .fusion-button-icon-divider,
                                        .fusion-button.button-1:active .fusion-button-icon-divider {
                                            border-color: #ffffff;
                                        }

                                        .fusion-button.button-1:hover,
                                        .fusion-button.button-1:focus,
                                        .fusion-button.button-1:active {
                                            border-color: #ffffff;
                                        }

                                        .fusion-button.button-1 {
                                            border-color: #333333;
                                            border-radius: 0px;
                                        }

                                        .fusion-button.button-1 {
                                            background: #ffffff;
                                        }

                                        .fusion-button.button-1:hover,
                                        .button-1:focus,
                                        .fusion-button.button-1:active {
                                            background: #ffffff;
                                        }
                                    </style>
                                    <textarea class="ng-app-input" (click)="resetError()" formControlName="answer"
                                        required></textarea>
                                    <div
                                        [ngStyle]="{'visibility':answerForm.get('answer').valid || answerForm.get('answer').pristine ? 'hidden':'visible'}">
                                        <i class="fas fa-exclamation-triangle"
                                            style="color: var(--ng-app-alert-color);"></i>
                                        <span style="padding-left: 5px;font-size: 14px;font-weight: 400;">Inserire la risposta.</span>
                                    </div>
                                </div>
                                <div class="ng-spinner">
                                    <img *ngIf="loadingAnswer"
                                        src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg" />
                                </div>
                                <div *ngIf="error !== 'no_error'">
                                    <i class="fas fa-exclamation-triangle"
                                        style="color: var(--ng-app-alert-color);"></i>
                                    <span style="padding-left: 5px;font-size: 14px;font-weight: 400;">
                                        Si è verificato un errore durante il salvataggio della risposta. Riprovare più
                                        tardi.
                                    </span>
                                </div>
                                <div class="fusion-button-wrapper fusion-aligncenter" style="padding-top: 20px;">
                                    <style type="text/css">
                                        .fusion-button.button-3 {
                                            border-radius: 0px;
                                        }
                                    </style><a (click)="submitAnswer(question)"
                                        class="fusion-button button-flat fusion-button-default-size button-default button-3 fusion-button-default-span fusion-button-default-type"
                                        target="_self"><span class="fusion-button-text">INVIA RISPOSTA</span></a>
                                </div>
                                <div class="fusion-sep-clear"></div>
                                <div class="fusion-separator fusion-full-width-sep sep-none"
                                    style="margin-left: auto;margin-right: auto;margin-top:20px;"></div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fusion-builder-row fusion-row" *ngIf="showMore">
    <div class="fusion-text">
        <p style="text-align: right;padding-top: 25px;margin-bottom: 0;"><a style="font-weight: 600;cursor: pointer;"
                (click)="loadMoreOngoingTenders()" target="_self">ALTRE DOMANDE &gt;</a></p>
    </div>
</div>